"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.senseScroll = exports.inferDepth = exports.imprintId = exports.getCurrentElement = void 0;
const Common_1 = require("../Common");
function getCurrentElement(target) {
    if (target instanceof Element) {
        return target;
    }
    if (target instanceof Document) {
        return target.documentElement;
    }
    return undefined;
}
exports.getCurrentElement = getCurrentElement;
function imprintId(target) {
    if (target.hasAttribute(Common_1.SENSING_ID_ATTRIBUTE_NAME)) {
        return target.getAttribute(Common_1.SENSING_ID_ATTRIBUTE_NAME);
    }
    const id = crypto.randomUUID();
    target.setAttribute(Common_1.SENSING_ID_ATTRIBUTE_NAME, id);
    return id;
}
exports.imprintId = imprintId;
function inferDepth(target) {
    const xmax = target.scrollWidth - target.clientWidth;
    const ymax = target.scrollHeight - target.clientHeight;
    if (xmax <= 0 && ymax <= 0) {
        return null;
    }
    return {
        x: xmax > 0 ? Math.round((target.scrollLeft / xmax) * 100) : 0,
        y: ymax > 0 ? Math.round((target.scrollTop / ymax) * 100) : 0,
    };
}
exports.inferDepth = inferDepth;
function senseScroll(callback) {
    const handleScrollEvent = (event) => {
        const target = getCurrentElement(event.target);
        if (!target) {
            return;
        }
        const senseId = imprintId(target);
        const scrollDepth = inferDepth(target);
        if (!scrollDepth)
            return;
        callback({ target, timestamp: Date.now(), senseId, scrollDepth });
    };
    document.addEventListener("scroll", handleScrollEvent, true);
    return () => {
        document.removeEventListener("scroll", handleScrollEvent, true);
    };
}
exports.senseScroll = senseScroll;
